module.exports = __webpack_public_path__ + "static/media/botonvolver.ce0afca9.svg";